export default "__VITE_ASSET__CV1FRnw1__"